import styled from "styled-components";
import LeftBanner from "../../../assets/sprites/navigation/header_left.jpg";
import MidBanner from "../../../assets/sprites/navigation/header_middle.jpg";

export const TopBanner = styled.div`
  background: url(${LeftBanner}), url(${MidBanner});
  background-position: left top, left top;
  background-repeat: no-repeat, repeat;
  background-size: auto 100%, auto 100%;
  width: 100%;
  height: 80px;
  border-radius: 25px 25px 0 0;
  border-bottom: 1px solid #2e2e2e;
`;
